import styled from 'styled-components'

import { fromMd, untilMd } from '@syconium/little-miss-figgy'

import { headerHeightPixels } from '../../../../../constants'

export const BaselineWrapper = styled.div`
  margin: ${o => o.theme.spacing(6)} auto;
  width: 100%;
  max-width: 600px;

  ${fromMd} {
    margin: ${o => o.theme.spacing(14)} auto;
  }
`

export const Heart = styled.span`
  font-size: 28px;

  &::after {
    content: '♥';
  }
`

export const Main = styled.main`
  min-height: 50vh;
  padding: ${o => o.theme.spacing(0, 3.5, 4.5, 3.5)};

  ${fromMd} {
    padding: ${o => o.theme.spacing(14, 9.5)};
  }
`

export const ReviewsSection = styled.ul`
  // The element should start higher and have a bigger top padding
  // so when we scroll to it, the header won't overlap it.
  margin: ${-headerHeightPixels}px auto 0;
  max-width: 1280px;
  padding-top: ${10 + headerHeightPixels}px;

  // On mobile we have a double sticky header (50px) so we should take that into account
  ${untilMd} {
    margin: ${-headerHeightPixels - 50}px auto 0;
    padding-top: ${10 + headerHeightPixels + 50}px;
  }
`

export const ReviewsLayout = styled.div`
  display: flex;

  ${fromMd} {
    column-gap: 80px;
  }
`

export const ProductReviewsWrapper = styled.div`
  min-width: 0px;
`

export const ProductReviewsList = styled.ul``

export const ProductReviewPhotosWrapper = styled.div`
  border-bottom: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  margin: ${o => o.theme.spacing(6, 0, 5, 0)};
  padding-bottom: ${o => o.theme.spacing(10)};

  ${fromMd} {
    margin: ${o => o.theme.spacing(5, 0, 0, 0)};
    padding-bottom: ${o => o.theme.spacing(5)};
  }
`

export const ProductReviewCardWrapper = styled.li`
  &:not(:last-child) {
    border-bottom: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  }
`

export const NewFormWrapper = styled.div`
  margin: 20px auto 0;
  max-width: 600px;
`

export const ThankYouHeadline = styled.h2`
  font-size: 21px;
  font-weight: bold;
  margin-top: 10px;
  text-transform: uppercase;
`

export const ThankYouSection = styled.div`
  border: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
  display: flex;
  flex-direction: column;
  padding: ${o => o.theme.spacing(10)};
  position: relative;
  text-align: center;

  svg g {
    color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
  }
`
